import type { AutocompleteUser } from '../components/FormSearchParticipants';

/** Display name for a participant row (search / print). */
export function getParticipantDisplayName(participant: AutocompleteUser): string {
  return participant.name || participant.email || participant.phone || participant.uid || '—';
}
